import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeIcon from '@mui/icons-material/Home';
import { Autocomplete, Box, Input, Checkbox, CircularProgress, FormControl, FormControlLabel, FormHelperText, Grid, InputLabel, LinearProgress, Link, IconButton, MenuItem, Paper, Select, SelectChangeEvent, SelectProps, TextField, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import { FieldAttributes, Form, Formik, useField } from 'formik';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate, useParams } from 'react-router-dom';
import { config } from '../../Constants';
import useAuth from "../../context/AuthProvider";
import { ClientFilingDefaultsPanel } from "../Elements/ClientFilingDefaultsPanel";
import { StateFilingCredentialsPanel } from "../Elements/StateFilingCredentialsPanel";
import { PartnerAgencyDetailsModel } from '../../models/PartnerAgencyDetails';
import { PartnerHierarchyItem, CompanyListItem, PartnersModel, PartnersModelVS } from '../../models/PartnersModel';
import { InsuranceCompanyCheckBox } from '../Elements/InsuranceCompanyCheckBox';
import { StateCheckBoxAgencyDetails } from '../Elements/StateCheckBoxAgencyDetails';
import { FMTextField } from '../Elements/input';
import { LoggedInUserInfo } from '../Elements/loggedInUserInfo';
import { FMSelectActiveInactive, FMSelectPartnerIntegrationType, FMSelectPartnerPaymentType, FMSelectState, PartnerContactEscalationSelect, PartnerContactMultiStateSelect } from '../Elements/select';
import { RightNav } from '../Nav/RightNav';
import { AddEditPartnerAgencyDetails } from './AddEditPartnerAgencyDetails';
import { useDropzone } from 'react-dropzone';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Swal from "sweetalert2";
import { RiExpandUpDownLine } from "react-icons/ri";
import { fontSize } from '@mui/system';
import { AppRoutes } from '../../helper/appRoutes';
import { Partners } from '../../Pages/Partners';
import { partnertaxesandfeesModel } from '../../models/PartnerTaxandFeeModel';
import { apiClient } from '../../helper/api';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';

// interface Iprops {
//     CustomerPartnersCL: PartnersModel,
//     handleClose: () => void,
//     Open: boolean,
//     handleSubmit: () => void
//     initValues: PartnersModel
//     selectedStates: stateOptions[]
// }
var formData = new FormData();

interface LicenseesContactInformation {
    partnerLincenseeInformationId: any;
    partnersId: any;
    cancellationDate: any;
    entity: any;
    fein: any;
    licenseNumber: any;
    licenseState: any;
    licensee: any;
    mainLicensee: any;
    npn: any;
    title: any;
}

// Interface for Partner Contact Information 
interface PartnerContactInformation {
  partnerContactInformationId: number;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  isAutoNotification?: boolean;
  escalationLevel?: number;
  stateIds?: number[];
  states?: { stateId: number; stateName: string }[];
  contactTypeId: number;
  contactType: string;
  dateCreated?: string;
  dateModified?: string;
}

const isPersistedPartnerContactId = (id: number | string | undefined | null): boolean => {
    const numericId = Number(id);
    return Number.isFinite(numericId) && numericId > 0;
};

const hasPartnerContactInput = (
  name: string,
  email: string,
  phone: string,
): boolean => Boolean(name.trim() || email.trim() || phone.trim());

export interface ReqFile {
    documentName?: string,

}

const ContactTypes = {
    Filing: "Filing",
    Accounting: "Accounting",
    SLAAdmin: "SLAAdmin",
    Escalation: "Escalation",
    DRLP: "DRLP",
};

export interface stateOptions {
    stateId: number,
    stateName: string,

}
export interface AgencyStateOptions {
    stateId: number,
    stateName: string,
    agencyLicense: string,

}

const baseStyle = {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    padding: '10px',
    borderWidth: 1,
    borderRadius: 8,
    borderColor: '#41729F',
    borderStyle: 'dashed',


    backgroundColor: '#fafafa',
    // color: '#bdbdbd',
    color: '#41729F',
    outline: 'none',
    transition: 'border .24s ease-in-out'
};

const focusedStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    borderColor: '#ff1744'
};

const selectFieldSx = {
    width: '100%',
    mt: '3px',
    '& .MuiSelect-select': { padding: '15.5px 16px' },
    '& .MuiOutlinedInput-notchedOutline': { border: '2px solid #e2e8f0 !important', borderRadius: '8px' },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.87) !important' },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976d2 !important' },
};
const textFieldSx = {
    '& .MuiOutlinedInput-notchedOutline': { border: '2px solid #e2e8f0 !important', borderRadius: '8px !important' },
    '& .MuiInputBase-input': { padding: '5px 14px !important' },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.87) !important' },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976d2 !important' },
};
const sectionTitleSx = { color: 'text.secondary', fontWeight: 600, letterSpacing: '0.08em', display: 'block', mb: 1 };
const paperSectionSx = { p: 2, borderRadius: 2, borderColor: 'divider', backgroundColor: 'grey.50' };


export interface PartnerInsuranceCompany {
    insuranceCompanyId: number,
    name: string,
}

export const AddEditPartners = () => {
    const initialValues: PartnersModel = {
        partnersId: 0,
        customerName: '',
        streetAddress: '',
        suitOrUnit: '',
        city: '',
        state: 0,
        zipCode: '',
        agencyLicense: '',
        taxId: '',
        numberOfStates: '',
        filingContactName: '',
        filingContactEmail: '',
        filingContactPhone: "",
        accountingContactName: '',
        accountingContactEmail: '',
        accountingContactPhone: "",
        licenseeContactName: '',
        licenseeContactEmail: '',
        licenseeContactPhone: "",
        slaAdminContactName: '',
        slaAdminContactEmail: '',
        slaAdminContactPhone: "",
        escalationContactName: '',
        escalationContactEmail: '',
        escalationContactPhone: "",
        drlpContactName: '',
        drlpContactEmail: '',
        drlpContactPhone: "",


        paymentPartnerType: 0,
        paymentStreetAddress: '',
        paymentSuitOrUnit: '',
        paymentCity: '',

        paymentZipCode: 0,
        paymentNaic: '',
        paymentTaxId: '',
        partnerIntegrationType: 0,
        agencyPolicyManagementSystem: '',
        userName: '',
        password: '',
        modifiedBy: 0,
        paymentType: true,
        paymentState: 0,
        createdBy: 0,
        status: false,
        latestTransactionNumber: '',
        previousCredit: 0,
        originalAmount: 0,
        carryForward: 0,
        generateSL1: false,
        signature: '',
        apiToken: '',
        isDiligentSearch: false,
        notes: '',
        isSurplusLinesTaxFilings: false,
        isConsulting: false,
        isLicensing: false,
        isOtherService: false,
        otherServiceNotes: '',
        companyId: null,
    }

    const [InitialData, setInitialData] = useState<PartnersModel>(initialValues);


    function GenericStyledDropZone(props: any) {


        const {
            getRootProps,
            getInputProps,
            acceptedFiles,
            isFocused,
            isDragAccept,
            isDragReject
        } = useDropzone({
            accept: { 'image/*': [] }, onDrop:
                (files) => {


                    console.log("initgenrateSL1 ", InitialData.generateSL1);
                    setInitialData({ ...InitialData, signature: URL.createObjectURL(files[0]) });
                    formData.delete("signaturedocument");
                    formData.append("signaturedocument", files[0]);

                    // files.map((file) => {
                    //     formData.append("props.doc.documentName", file);
                    // });

                }
        });

        const style = useMemo(() => ({
            ...baseStyle,
            ...(isFocused ? focusedStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {})
        }), [
            isFocused,
            isDragAccept,
            isDragReject
        ]);


        const files = acceptedFiles.map
            (
                file =>
                (
                    <React.Fragment>
                        <FilePresentIcon fontSize='inherit' />
                        <li key={file.name}>
                            {file.name} - {(file.size / 1024).toFixed(2)} kb
                        </li>
                    </React.Fragment>
                )

            );

        return (
            <React.Fragment>
                <div className="card-body col-lg-12">

                    <div {...getRootProps({ style })}>

                        <input {...getInputProps()} name={"Signature document"} />
                        <p>Drop Signature here if you want to update it  <span style={{ color: "red" }}></span> </p>

                    </div>
                    <aside>
                        <ul>{files}</ul>
                    </aside>
                </div>

            </React.Fragment>
        );
    }
    const navigate = useNavigate();
    // const initialdata = { stateId: "", stateName: "" };
    const params = useParams();

    const [selectedStates, setselectedStates] = useState<AgencyStateOptions[]>([]);


    const { user } = useAuth();
    var isUserAdmin=user?.userRoles.split(",").includes("Super Admin");
    const token = user?.token;
    const [parentClientOptions, setParentClientOptions] = useState<PartnerHierarchyItem[]>([]);
    const [companyOptions, setCompanyOptions] = useState<CompanyListItem[]>([]);
    // const navigate1 = useNavigate();
    const goBack = () => {
        navigate(-1);
    }
    const [DiligentSearch, setDiligentSearch] = useState<boolean>(false)
    const [partnerNotes, setPartnerNotes] = useState<string>('')
    const [isSurplusLinesTaxFilings, setIsSurplusLinesTaxFilings] = useState<boolean>(false)
    const [isConsulting, setIsConsulting] = useState<boolean>(false)
    const [isLicensingService, setIsLicensingService] = useState<boolean>(false)
    const [isOtherService, setIsOtherService] = useState<boolean>(false)
    const [otherServiceNotes, setOtherServiceNotes] = useState<string>('')
    function handleDiligentSearch() {
        var value = DiligentSearch == true ? false : DiligentSearch === null || DiligentSearch === undefined || DiligentSearch == false ? true : false
        setDiligentSearch(value);
    }

    const parsePartnerBool = (value: unknown): boolean =>
        value === true || value === 'true' || value === 1 || value === '1';


    const [partnerAgencyDetailList, setPartnerAgencyDetailList] = useState<PartnerAgencyDetailsModel[]>([]);
    let iniAgencyValues: PartnerAgencyDetailsModel = {
        partnerAgencyDetailsId: 0,
        firstName: "",
        lastName: "",
        licenseNumber: "",
        slBrokerNumber: "",
        agencyLicenseNumber: "",
        latestTransactionNumber: "",
        nationalProducerNumber: "",
        previousCredit: 0,
        carryForward: 0,
        originalAmount: 0,
        individualNPN: "",
        dateLicensed: undefined,
    }
    const [PartnerAgencyData, setPartnerAgencyData] = useState<PartnerAgencyDetailsModel>(iniAgencyValues);


    const [loading, setloading] = useState(false);

    const [selectedPartnerInsuranceCompany, setselectedPartnerInsuranceCompany] = useState<PartnerInsuranceCompany[]>([]);
    const [PartnerInsuranceCompany, setPartnerInsuranceCompany] = useState<PartnerInsuranceCompany[]>([])

    const [StateName, setStateName] = useState<string>("")

    const initContactInformation: PartnerContactInformation = {
        partnerContactInformationId: 0,
        isAutoNotification: false,
        escalationLevel: 0,
        contactName: '',
        contactEmail: '',
        contactPhone: '',
        contactTypeId: 0,
        contactType: ''
    };

    const tempPartnerContactIdRef = useRef(-1);
    const createNewPartnerContactRow = (): PartnerContactInformation => ({
        partnerContactInformationId: tempPartnerContactIdRef.current--,
        isAutoNotification: false,
        escalationLevel: 0,
        stateIds: [],
        contactName: '',
        contactEmail: '',
        contactPhone: '',
        contactTypeId: 0,
        contactType: '',
    });

    var initLicenseeContactInformation: LicenseesContactInformation = {
        partnerLincenseeInformationId: 0,
        partnersId: 0,
        cancellationDate: '',
        entity: false,
        fein: '',
        licenseNumber: '',
        licenseState: '',
        licensee: '',
        mainLicensee: false,
        npn: '',
        title: ''
    };

    const [filingContactArry, setFilingContactArry] = useState<PartnerContactInformation[]>(() => [createNewPartnerContactRow()]);
    const [acountingContactArry, setAcountingContactArry] = useState<PartnerContactInformation[]>(() => [createNewPartnerContactRow()]);
    const [slaAdminContactArry, setSLAAdminContactArry] = useState<PartnerContactInformation[]>(() => [createNewPartnerContactRow()]);
    const [escalationContactArry, setEscalationContactArry] = useState<PartnerContactInformation[]>(() => [createNewPartnerContactRow()]);
    const [drlpContactArry, setDRLPContactArry] = useState<PartnerContactInformation[]>(() => [createNewPartnerContactRow()]);
    // const [licenseesContactArry, setLicenseesContactArry] = useState([initLicenseeContactInformation]);
    const [licenseesContactArry, setLicenseesContactArry] = useState<LicenseesContactInformation[]>([]);

    const [isLicenseesInfoLoading, setisLicenseesInfoLoading] = useState(true);

    const [PartnerId1, setPartnerId] = useState<string>('');
        const [customerId, setCustomerId] = useState<number>(0);



    const [Open, setOpen] = React.useState(false);
    const handleCustomerIdChange = (id: number) => {
        console.log("Received customerId from LicenseMatrix:", id);
        setCustomerId(id);
      };


    const updatePartnerContactField = (
        contactId: number,
        field: 'contactName' | 'contactEmail' | 'contactPhone' | 'isAutoNotification' | 'escalationLevel' | 'stateIds',
        value: string | boolean | number | number[],
        setContacts: React.Dispatch<React.SetStateAction<PartnerContactInformation[]>>,
    ) => {
        setContacts((previousContacts) =>
            previousContacts.map((contact) =>
                contact.partnerContactInformationId === contactId
                    ? { ...contact, [field]: value }
                    : contact,
            ),
        );
    };

    function mapContactArray(arr: PartnerContactInformation[]) {
        return arr?.map((item) => ({
            PartnerContactInformationId: isPersistedPartnerContactId(item.partnerContactInformationId)
                ? Number(item.partnerContactInformationId)
                : null,
            ContactName: item.contactName?.trim() || '',
            ContactEmail: item.contactEmail?.trim() || '',
            ContactPhone: item.contactPhone?.trim() || '',
            IsAutoNotification: Boolean(item.isAutoNotification),
            EscalationLevel: Math.min(2, Math.max(0, Number(item.escalationLevel ?? 0) || 0)),
        })).filter((contact) => hasPartnerContactInput(
            contact.ContactName,
            contact.ContactEmail,
            contact.ContactPhone,
        )) || [];
    }

    function mapDrlpContactArray(arr: PartnerContactInformation[]) {
        return arr?.map((item) => ({
            PartnerContactInformationId: isPersistedPartnerContactId(item.partnerContactInformationId)
                ? Number(item.partnerContactInformationId)
                : null,
            ContactName: item.contactName?.trim() || '',
            ContactEmail: item.contactEmail?.trim() || '',
            ContactPhone: item.contactPhone?.trim() || '',
            IsAutoNotification: Boolean(item.isAutoNotification),
            EscalationLevel: Math.min(2, Math.max(0, Number(item.escalationLevel ?? 0) || 0)),
            StateIds: (item.stateIds ?? [])
                .map((stateId) => Number(stateId))
                .filter((stateId) => Number.isFinite(stateId) && stateId > 0),
        })).filter((contact) => hasPartnerContactInput(
            contact.ContactName,
            contact.ContactEmail,
            contact.ContactPhone,
        )) || [];
    }


    const fetchPartnerAgencyData = (stateId: string) => {

        setloading(true);
        apiClient(`/PartnerAgencyDetails/getById?partnersId=${params.partnersId}&&stateId=${stateId}`,
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
            .then((responseJson) => {
                if (!responseJson) return
                // Do something with the response

                if (responseJson.data !== null) {

                    const finalData: PartnerAgencyDetailsModel = {
                        partnerAgencyDetailsId: responseJson.data.partnerAgencyDetailsId,
                        agencyLicenseNumber: responseJson.data?.agencyLicenseNumber ?? "",
                        nationalProducerNumber: responseJson.data?.nationalProducerNumber ?? "",
                        latestTransactionNumber: InitialData.latestTransactionNumber,
                        firstName: responseJson.data?.firstName ?? "",
                        lastName: responseJson.data?.lastName ?? "",
                        licenseNumber: responseJson.data?.licenseNumber ?? "",
                        partnersId: responseJson.data.partnersId,
                        slBrokerNumber: responseJson.data?.slBrokerNumber ?? "",
                        stateID: responseJson.data?.stateID,
                        taxId: responseJson.data?.taxId ?? "",
                        originalAmount: InitialData.originalAmount,
                        carryForward: InitialData.carryForward,
                        previousCredit: InitialData.previousCredit,
                        individualNPN: responseJson.data?.individualNPN,
                        dateLicensed: responseJson.data?.dateLicensed ? new Date(responseJson.data?.dateLicensed).toISOString().split('T')[0] : undefined,
                    }
                    console.log('get agency finalData', { finalData })
                    setPartnerAgencyData(finalData);

                } else {

                    iniAgencyValues.stateID = Number(stateId);

                    iniAgencyValues.partnersId = Number(params.partnersId);


                    setPartnerAgencyData(iniAgencyValues);
                }

            }).finally(() => {
                setloading(false);
            });


    }


    function addselectedStates(stateId: string, licenseNumber?: string) {

        let crrOption: AgencyStateOptions =
        {
            stateId: Number(stateId),
            stateName: '',
            agencyLicense: licenseNumber ?? '',

        }
        // var selStates = selectedStates.filter(e=>e.stateId === Number( stateId));
        setselectedStates(current => [...current.filter(e => e.stateId !== Number(stateId)), crrOption]);

    }
    function RemoveSelected(stateId: string) {

        setPartnerAgencyDetailList(
            partnerAgencyDetailList.filter(obj =>
                obj.stateID !== Number(stateId),
            )
        );

        setselectedStates(
            selectedStates.filter(obj =>
                obj.stateId !== Number(stateId),

            )

        )

    }

    const handleCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let statename =
            States.filter(e =>
                e.stateId === Number(event.target.name)
            )[0].stateName ?? "";

        setStateName(statename);



        if (!event.target.checked) {

            fetchPartnerAgencyData(event.target.name);
            setOpen(true);

        } else {
            iniAgencyValues.stateID = Number(event.target.name);

            iniAgencyValues.partnersId = Number(params.partnersId);
            setPartnerAgencyData(iniAgencyValues);
            setOpen(true);

        }


    };

    const handleInsuranceCompanyCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {


            let crrOption: PartnerInsuranceCompany = {
                insuranceCompanyId: Number(event.target.name),
                name: ''
            }
            setselectedPartnerInsuranceCompany(current => [...current, crrOption]);

        } else {

            setselectedPartnerInsuranceCompany(
                selectedPartnerInsuranceCompany.filter(obj =>
                    obj.insuranceCompanyId !== Number(event.target.name)
                )
            )
        }

    };

    const [isContactInfoLoading, setisContactInfoLoading] = useState(true);
    const [isaccountInfoLoading, setisaccountInfoLoading] = useState(true);

    const [isSLAAdminInfoLoading, setisSLAAdminInfoLoading] = useState(true);
    const [isEscalationInfoLoading, setisEscalationInfoLoading] = useState(true);
    const [isDRLPInfoLoading, setisDRLPInfoLoading] = useState(true);
    const [showOtherTextField, setShowOtherTextField] = useState(false);


    const fetchStates = () => {

        apiClient('/States/getStates',
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
            .then((responseJson) => {
                if (!responseJson) return
                // Do something with the response

                setStates(responseJson.data);


            }).then(() => {
                apiClient(`/Partners/getPartnerStates?partnersId=${params.partnersId}`,
                    {
                        method: "GET",
                        headers: new Headers({
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        })
                    })
                    .then((responseJson) => {
                        if (responseJson?.data == null) return
                        setselectedStates(responseJson.data);
                        setloading(false);

                        // setSelectedOption(States.filter(x => partnerStates.map((item)=>(item.stateId))));
                    })
            })


    }
    const fetchData = () => {

        if (params.partnersId !== '0') {

            apiClient(`/Partners/getPartnerById?partnersId=${params.partnersId}`,
                {
                    method: "GET",
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    })
                }).then((responseJson) => {
                    if (responseJson?.data == null) return
                    // Do something with the response
                    setInitialData({
                        ...responseJson.data,
                        notes: responseJson.data.notes ?? responseJson.data.Notes ?? '',
                    });
                    setDiligentSearch(parsePartnerBool(responseJson.data.isDiligentSearch));
                    setPartnerNotes(
                        responseJson.data.notes
                            ?? responseJson.data.Notes
                            ?? ''
                    );
                    setIsSurplusLinesTaxFilings(parsePartnerBool(
                        responseJson.data.isSurplusLinesTaxFilings
                            ?? responseJson.data.IsSurplusLinesTaxFilings
                    ));
                    setIsConsulting(parsePartnerBool(
                        responseJson.data.isConsulting
                            ?? responseJson.data.IsConsulting
                    ));
                    setIsLicensingService(parsePartnerBool(
                        responseJson.data.isLicensing
                            ?? responseJson.data.IsLicensing
                    ));
                    const otherService = parsePartnerBool(
                        responseJson.data.isOtherService
                            ?? responseJson.data.IsOtherService
                    );
                    setIsOtherService(otherService);
                    setOtherServiceNotes(
                        responseJson.data.otherServiceNotes
                            ?? responseJson.data.OtherServiceNotes
                            ?? ''
                    );
                    setShowOtherTextField(otherService);
                    responseJson.data.generateSL1 == true ? setSelectedValue('true') : setSelectedValue('false');
                    fetchDataStates();

                })

        }


    }

    useEffect(() => {
        if (!isUserAdmin || params.partnersId === '0' || !token) {
            setParentClientOptions([]);
            return;
        }
        apiClient('/Partners/getPartnersHierarchy', {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            }),
        }).then((res) => {
            const list: PartnerHierarchyItem[] = res?.data || [];
            const selfId = Number(params.partnersId);
            setParentClientOptions(list.filter((p) => p.companyId === null && p.partnersId !== selfId));
        });
    }, [params.partnersId, token, isUserAdmin]);

    useEffect(() => {
        if (!isUserAdmin || !token) {
            setCompanyOptions([]);
            return;
        }
        apiClient('/Partners/getCompanies', {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            }),
        }).then((res) => {
            setCompanyOptions(res?.data || []);
        });
    }, [token, isUserAdmin]);

     // New refactored endpoint to fetch Partner contact information 
    const fetchPartnerContactInfo = (
      contactType: string,
      setState: React.Dispatch<React.SetStateAction<any[]>>,
      setLoading: React.Dispatch<React.SetStateAction<boolean>>
    ) => {
      if (params.partnersId !== "0") {
        apiClient(`/Partners/getContactsByType?partnerId=${params.partnersId}&contactType=${contactType}`, {
          method: "GET",
          headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          })
        })
          .then((responseJson) => {
            if (responseJson?.data == null) return;
            const contacts = Array.isArray(responseJson.data)
              ? responseJson.data.map((contact: PartnerContactInformation) => ({
                  ...contact,
                  partnerContactInformationId: Number(contact.partnerContactInformationId),
                  contactName: contact.contactName ?? '',
                  contactEmail: contact.contactEmail ?? '',
                  contactPhone: contact.contactPhone ?? '',
                  isAutoNotification: Boolean(contact.isAutoNotification),
                  escalationLevel: Math.min(2, Math.max(0, Number(contact.escalationLevel ?? 0) || 0)),
                  stateIds: Array.isArray(contact.stateIds)
                    ? contact.stateIds.map((stateId) => Number(stateId)).filter((stateId) => Number.isFinite(stateId) && stateId > 0)
                    : [],
                }))
              : [];
            setState(contacts.length > 0 ? contacts : [createNewPartnerContactRow()]);
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        setLoading(false);
      }
    };

    const fetchLicensessData = () => {
        apiClient(`/Partners/getLicenseesContactInformationById?partnerId=${params.partnersId}`, {
            method: "GET",
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            })
        })
            .then((responseJson) => {
                if (responseJson?.data == null) return
                setLicenseesContactArry(responseJson.data);
                // } else {
                //     setLicenseesContactArry([initLicenseeContactInformation]);
            }).finally(() => {
                setisLicenseesInfoLoading(false);
            });
    };


    const fetchDataStates = () => {

        apiClient('/States/getStates',
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
            .then((responseJson) => {
                // Do something with the response
                if (responseJson?.data == null) return

                setStates(responseJson.data);
                setSelected(States.find(x => x.stateId === responseJson.data.state) ?? null);

            })

    }


    const [GeneratedApi, setGeneratedApi] = useState<string>("")


    const handleButtonClick = (setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void) => {
        apiClient("/Partners/generateApiKey", {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
        })
            .then((responseJson) => {
                if (!responseJson) return

                if (responseJson.data != null) {
                    // InitialData.apiToken = responseJson.data;
                    setGeneratedApi(responseJson.data);
                    setFieldValue("apiToken", responseJson.data);

                }
                console.log("generatedApi key", responseJson.data);
            })

        // handleInputChange(e);


    };

    const fetchInsuranceCompany = () => {
        apiClient('/InsuranceCompany/getInsuranceCompanySelect',
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
            .then((responseJson) => {
                if (!responseJson) return
                // Do something with the response

                setPartnerInsuranceCompany(responseJson.data);
                // console.log(States);

            }).then(() => {
                apiClient(`/Partners/getPartnerInsuranceCompany?partnerId=${params.partnersId}`,
                    {
                        method: "GET",
                        headers: new Headers({
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        })
                    })
                    .then((responseJson) => {
                        if (responseJson?.data == null) return
                        // Do something with the response

                        setselectedPartnerInsuranceCompany(responseJson.data);

                        // setSelectedOption(States.filter(x => partnerStates.map((item)=>(item.stateId))));
                    })
            })

    }


    const [States, setStates] = useState<stateOptions[]>([]);
    const [selectedOption, setSelected] = useState<stateOptions | null>(null);
    
    const FMSelectStateCustom: React.FC<FieldAttributes<SelectProps>> = ({ variant, ...props }) => {
        const [field, meta] = useField<{}>(props);
        const errorText = meta.error && meta.touched ? meta.error : "";
        const handleOptionChange = (event: React.ChangeEvent<{}>, newValue: stateOptions | null) => {
            setSelected(newValue);
        };
        useEffect(() => {
            // fetchData();

        }, [])
        return (
            <FormControl error={!!errorText} fullWidth  >
                {/* <InputLabel >State</InputLabel> */}
                <Select
                    {...field}
                    labelId="State-Select-Label"
                    className="border-round"
                    IconComponent={ExpandMoreIcon}
                    sx={selectFieldSx}
                >
                    <MenuItem key={0} value={0}> Select State </MenuItem>
                    {States.map((state, key) =>
                        <MenuItem key={key} value={state.stateId}> {state.stateName} </MenuItem>

                    )}

                </Select>
                {/* <Autocomplete
                    options={States}
                    getOptionLabel={(option) => option.stateName}
                    value={selectedOption}
                    onChange={handleOptionChange}
                   
                    renderInput={(params) => (
                        <TextField {...params} label="" name="state" variant="outlined" />
                    )}
                /> */}
                <FormHelperText>{errorText}</FormHelperText>
            </FormControl>

        )
    }

    const [generateSL1, setGenerateSL1] = useState<boolean>();
    const [selectedValue, setSelectedValue] = useState<string | undefined>();
    const handleChange = (event: SelectChangeEvent) => {

        setSelectedValue(event.target.value);
        if (event.target.value === 'true') {
            setGenerateSL1(true);

        } else {
            setGenerateSL1(false);
        }
    };

    const FMSelectTrueFalseCustom: React.FC<FieldAttributes<SelectProps>> = ({ variant, ...props }) => {
        const [field, meta] = useField<{}>(props);
        const errorText = meta.error && meta.touched ? meta.error : "";

        return (
            <React.Fragment>
                <FormControl error={!!errorText} fullWidth sx={{ m: 0 }}>
                    {/* <FormHelperText className='formtexthelper-heading' > </FormHelperText> */}
                    {/* <InputLabel id="Select-Label">Auto Generate SL1</InputLabel> */}
                    <FormHelperText className="formtexthelper-heading">Auto Generate SL1</FormHelperText>
                    <Select {...field}
                        labelId="Select-Label"
                        label={null}
                        className="border-round"
                        IconComponent={ExpandMoreIcon}
                        value={selectedValue || ""}
                        onChange={handleChange}
                        sx={selectFieldSx}
                    >
                        <MenuItem value={'true'}>True</MenuItem>
                        <MenuItem value={'false'}>False</MenuItem>
                    </Select>

                </FormControl>
            </React.Fragment>
        );
    };

    const handleDeleteLicensee = (id: number) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                
                apiClient("/Partners/deleteLicensee?id=" + `${id}`, {
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    }),
                    method: "DELETE",
                })
                    .then((res) => {
                        if (!res) return
                        Swal.fire(
                            'Deleted!',
                            'Your file has been deleted.',
                            'success'
                        )
                        fetchLicensessData();
                    }).finally(() => {
                        setOpen(false);
                    });
            }
        });
    };

    // function to delete partner contact by contact type
       const handleDeletePartnerContactByContactType = (
      id: number,
      contactType: string,
      onSuccess?: () => void,
      onRemoveFromUI?: () => void
    ) => {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#02A4E3',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete',
        customClass: {
          confirmButton: 'btn-radius',
          cancelButton: 'btn-radius',
          popup: 'card-radius'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          onRemoveFromUI?.();
          if (!isPersistedPartnerContactId(id)) {
            Swal.fire('Removed', 'Contact removed.', 'success');
            return;
          }
          apiClient(`/Partners/deletePartnerContactByContactType?id=${id}&contactType=${contactType}`, {
            method: "DELETE",
            headers: new Headers({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            })
          })
            .then((res) => {
                console.log("Delete response:", res);
              if (!res) return;
              Swal.fire('Deleted!', 'This contact has been deleted.', 'success');
              if (onSuccess) onSuccess();
            })
            .catch(() => {
              Swal.fire('Error', 'Failed to delete contact.', 'error');
            })
            .finally(() => {
              setOpen(false);
            });
        }
      });
    };


    const initPartnerTaxFeeData: partnertaxesandfeesModel = {
        partnerTaxesandFeeId: 0,
        rate: 0
    }
    const [PartnerTaxesAndFee, setPartnerTaxesAndFee] = useState<partnertaxesandfeesModel[]>([])

    const fetchPartnerTaxAndFe = () => {
        
        
        apiClient(`/Partners/getPartnerTaxandFeeData?partnersId=${params.partnersId}`,
            {

                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
            .then((res) => {
                if (!res) return
                
                if (res.data !== null)
                    setPartnerTaxesAndFee(res.data)

                else
                    // setPartnerTaxesAndFee([initPartnerTaxFeeData]);
                    setloading(false);
                console.log(res.data);

            }).finally(() => {
                setloading(false);
            });

    }


    useEffect(() => {
        fetchLicensessData();
        //fetchCustomerData();
        fetchStates();
        fetchData();
        fetchInsuranceCompany();
        //fetchAccountinfoData();
        //fetchSLAAdminData();
        //fetchEscalationData();
        //fetchDRLPData();
        fetchPartnerTaxAndFe();
        fetchPartnerContactInfo("Filing", setFilingContactArry, setisContactInfoLoading);
        fetchPartnerContactInfo("Accounting", setAcountingContactArry, setisaccountInfoLoading);
        fetchPartnerContactInfo("SLA", setSLAAdminContactArry, setisSLAAdminInfoLoading);
        fetchPartnerContactInfo("Escalation", setEscalationContactArry, setisEscalationInfoLoading);
        fetchPartnerContactInfo("DRLP", setDRLPContactArry, setisDRLPInfoLoading);



    }, [])


    return (

        <React.Fragment>

            <Formik initialValues={InitialData}
                enableReinitialize={true}
                validateOnChange={true}
                validationSchema={PartnersModelVS}

                onSubmit={(data, { setSubmitting }) => {
                    
                    data.partnerTaxAndFeesDTO = PartnerTaxesAndFee;
                    data.partnerAgencyDetails = partnerAgencyDetailList;

                    data.generateSL1 = selectedValue === 'true' ? true : false;

                    if (selectedValue === 'true' && data.signature === '') {

                        alert("Signature required");
                        return;
                    }
                    if (selectedValue === 'false') {
                        data.signature = '';
                    }


                    data.isDiligentSearch = DiligentSearch;
                    data.isSurplusLinesTaxFilings = isSurplusLinesTaxFilings;
                    data.isConsulting = isConsulting;
                    data.isLicensing = isLicensingService;
                    data.isOtherService = isOtherService;
                    data.otherServiceNotes = isOtherService ? otherServiceNotes : '';
                    // Notes uses local state (same pattern as DiligentSearch)
                    // so enableReinitialize cannot wipe the value before submit.
                    data.notes = partnerNotes;
                    // data.apiToken = GeneratedApi;

                    console.log("FinalDataa", data);
                    if (partnerAgencyDetailList.length > 0) {

                        data.latestTransactionNumber = partnerAgencyDetailList.find(x => x.stateID === 30)?.latestTransactionNumber;
                        data.previousCredit = partnerAgencyDetailList.find(x => x.stateID === 14)?.previousCredit;
                        data.originalAmount = partnerAgencyDetailList.find(x => x.stateID === 14)?.originalAmount;
                        data.carryForward = partnerAgencyDetailList.find(x => x.stateID === 14)?.carryForward;



                        // alert("Select Agency Data in States");
                        // setSubmitting(false);
                        // return;
                    }



                    data.partnersId = Number(params.partnersId ?? 0);
                    (data as PartnersModel & { userId?: number }).userId = user?.userId ?? 0;
                    if (data.partnersId !== 0) {
                        data.userName = "";
                        data.password = "";
                    }

                    data.numberOfStates = selectedStates.map(x => x.stateId).join(",");

                    setloading(true);

                    data.selectedInsuranceCompany = selectedPartnerInsuranceCompany.map(x => x.insuranceCompanyId).join(",");


                    var Licenseedata = "";

                    // DRY mapping for all contact types
                    const filingContactsJson = mapContactArray(filingContactArry);
                    const accountingContactsJson = mapContactArray(acountingContactArry);
                    const slaAdminContactsJson = mapContactArray(slaAdminContactArry);
                    const escalationContactsJson = mapContactArray(escalationContactArry);
                    const drlpContactsJson = mapDrlpContactArray(drlpContactArry);

                    const licenseeContactsJson = licenseesContactArry?.map((item) => {
                        const isExistingContact = item.partnerLincenseeInformationId && 
                                                 item.partnerLincenseeInformationId < 1000000000000;
                        return {
                            PartnerLincenseeInformationId: isExistingContact ? item.partnerLincenseeInformationId : null,
                            CancellationDate: item.cancellationDate,
                            Entity: item.entity || false,
                            Fein: item.fein,
                            LicenseNumber: item.licenseNumber,
                            LicenseState: item.licenseState,
                            Licensee: item.licensee,
                            MainLicensee: item.mainLicensee || false,
                            Npn: item.npn,
                            Title: item.title || ''
                        };
                    }) || [];

                    // Assign to payload
                    data.contactInformation = filingContactsJson;
                    data.accontInformation = accountingContactsJson;
                    data.licenseeContactInformation = licenseeContactsJson;
                    data.slaAdminInformation = slaAdminContactsJson;
                    data.escalationContactInformation = escalationContactsJson;
                    data.dRLPContactInformation = drlpContactsJson;

                    console.log("All contact JSON being sent:", {
                        filing: filingContactsJson,
                        accounting: accountingContactsJson,
                        sla: slaAdminContactsJson,
                        escalation: escalationContactsJson,
                        drlp: drlpContactsJson,
                        licensee: licenseeContactsJson
                    });    

                    // Log the payload before sending
                    console.log("Payload being sent to backend:", data);
                    console.log("Serialized JSON Payload being sent to the backend:", JSON.stringify(data));


                    setloading(true);
                    // formData is module-scoped and reused across submits; clear any
                    // prior payload so the backend receives a single "data" entry
                    // (duplicate entries arrive as an array and every field reads undefined).
                    formData.delete("data");
                    formData.append("data", JSON.stringify(data));
                    console.log("Final DAta", formData);
                    
                    const isEdit = params.partnersId && params.partnersId !== '0';
                    const endpoint = isEdit 
                        ? '/Partners/updatePartner' 
                        : '/Partners/createPartner';
                    const method = isEdit ? 'PUT' : 'POST';
                    apiClient(endpoint, {
                        method: method,
                        headers: new Headers({
                            'Authorization': `Bearer ${token}`,
                        }),
                        body: formData
                    })
                    .then((res) => {
                        if (!res?.status) {
                            Swal.fire('Error', res?.message || 'Failed to save partner.', 'error');
                            return;
                        }
                        navigate(AppRoutes.partners);
                    }).finally(() => {
                        setloading(false);
                        setSubmitting(false);
                    }); 
                    // apiClient('/Partners/AddEdit',
                    //     {
                    //         method: 'POST',

                    //         headers: new Headers({
                    //             // 'Content-Type': 'application/json',
                    //             'Authorization': `Bearer ${token}`,
                    //         }),
                    //         // body: JSON.stringify(data) 
                    //         body: formData  // <-- Post parameters

                    //     })
                    //     .then((res) => {
                    //         if (!res) return
                    //         // Do something with the response
                    //         navigate("/Partners");

                    //         setloading(false);

                    //     }).finally(() => {
                    //         setloading(false);
                    //         setSubmitting(false);
                    //     });

                }} >
                {({ values, isSubmitting, setFieldValue }) => (
                    <React.Fragment>
                        <Form className='main-form' >

                            <Box sx={{ pb: 3 }}>
                                <Box sx={{ mb: 2 }}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            gap: 1.5,
                                            px: 2,
                                            py: 2.5,
                                            borderBottom: "1px solid #e2e8f0",
                                            backgroundColor: "#fafbfc",
                                            minHeight: 56,
                                            mb: 3,
                                        }}
                                    >
                                        <Typography
                                            component="h2"
                                            variant="h5"
                                            sx={{ fontWeight: 600, color: '#0f172a' }}
                                        >
                                            {params.partnersId === '0' ? 'New Client Submission' : 'Edit Client'}
                                        </Typography>
                                    </Box>

                                    <Grid container spacing={3} sx={{ mb: 3 }}>
                                        <Grid item xs={12}>
                                            <Typography variant="overline" sx={sectionTitleSx}>
                                                General Information
                                            </Typography>
                                            <Paper variant="outlined" sx={paperSectionSx}>
                                                <Grid container spacing={2}>
                                                <Grid item xs={12} md={6}>
                                                    <FormControl sx={{ width: '100%' }}>
                                                        <FormHelperText className="formtexthelper-heading">Client Name</FormHelperText>
                                                        <FMTextField name="customerName" autoFocus margin="dense" label={null} type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <FormControl sx={{ width: '100%' }}>
                                                        <FormHelperText className="formtexthelper-heading">Street Address</FormHelperText>
                                                        <FMTextField name="streetAddress" label={null} type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <FormControl sx={{ width: '100%' }}>
                                                        <FormHelperText className="formtexthelper-heading">Suite or Unit</FormHelperText>
                                                        <FMTextField name="suitOrUnit" label={null} type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <FormControl sx={{ width: '100%' }}>
                                                        <FormHelperText className="formtexthelper-heading">City</FormHelperText>
                                                        <FMTextField name="city" label={null} margin="dense" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <FormControl sx={{ width: '100%' }}>
                                                        <FormHelperText className="formtexthelper-heading">State</FormHelperText>
                                                        <FMSelectStateCustom name='state' />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <FormControl sx={{ width: '100%' }}>
                                                        <FormHelperText className="formtexthelper-heading">ZIP</FormHelperText>
                                                        <FMTextField name="zipCode" label={null} InputLabelProps={{ shrink: true }} margin="dense" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={4}>
                                                    <FormControl sx={{ width: '100%' }}>
                                                        <FormHelperText className="formtexthelper-heading">National Producer Number</FormHelperText>
                                                        <FMTextField name="nPN" label={null} margin="dense" InputLabelProps={{ shrink: true }} type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={4}>
                                                    <FormControl sx={{ width: '100%' }}>
                                                        <FMSelectActiveInactive name="status" />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={4}>
                                                    <FormControl sx={{ width: '100%' }}>
                                                        <FMSelectTrueFalseCustom name="generateSL1" />
                                                    </FormControl>
                                                </Grid>

                                                {isUserAdmin && (
                                                    <Grid item xs={12}>
                                                        <FormHelperText className="formtexthelper-heading">Parent company (billing rollup)</FormHelperText>
                                                        <FormControl sx={{ width: '100%', marginBottom: 2 }}>
                                                            <Select
                                                                displayEmpty
                                                                value={values.companyId ?? ''}
                                                                onChange={(e) => {
                                                                    const v = e.target.value;
                                                                    if (v === '') {
                                                                        setFieldValue('companyId', null);
                                                                    } else {
                                                                        setFieldValue('companyId', Number(v));
                                                                    }
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                                sx={selectFieldSx}
                                                            >
                                                                <MenuItem value="">None (standalone client)</MenuItem>
                                                                {companyOptions.map((c) => (
                                                                    <MenuItem key={c.companyId} value={c.companyId}>
                                                                        {c.companyName}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                )}

                                                {selectedValue === 'true' && (
                                                    <>
                                                        <Grid item xs={12} md={6}>
                                                            <FormHelperText className="formtexthelper-heading">Signature</FormHelperText>
                                                            <div className="card-body card-body-dashboard">
                                                                <GenericStyledDropZone key={1} />
                                                            </div>
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <FormControl sx={{ width: '100%' }}>
                                                                {InitialData.signature && <img src={InitialData.signature} alt="Signature" style={{ maxWidth: '100%' }} />}
                                                            </FormControl>
                                                        </Grid>
                                                    </>
                                                )}
                                                </Grid>
                                            </Paper>
                                        </Grid>

                                        {/* States section - commented out */}
                                        {/* <Grid item sm={12} md={12} lg={12} xl={4} marginLeft="3vw" marginBottom="50px">
                                            <Grid item xs={12} display='flex' >
                                                <span className="sub-card-title" >States</span>
                                            </Grid>
                                            <Grid item xs={12}  >
                                                <div className="card overflow-auto  state-box" style={{ height: "60vh", margin: "0px" }}>
                                                    <div className=" " >
                                                        <Grid item xs={12} container spacing={3} marginTop={"5px"} direction="row" justifyContent="space-between" marginLeft={4}> */}
                                        {/* <Grid item xs={4}>
                                                                <Button variant="contained" color="primary" onClick={selectAll} sx={{ width: "100%" }} >Select-All</Button>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <Button variant="contained" color="primary" onClick={disSelectAll} sx={{ width: "100%" }} >Deselect-All </Button>
                                                            </Grid> */}
                                        {/* </Grid>
                                                        <StateCheckBoxAgencyDetails selectedStates={selectedStates} States={States} handleCheckBoxChange={handleCheckBoxChange} />
                                                    </div>
                                                </div>
                                            </Grid>
                                        </Grid> */}
                                    </Grid>
                                    <Grid item xs={12} sx={{ mb: 3 }}>
                                        <Typography variant="overline" sx={sectionTitleSx}>Notes</Typography>
                                        <Paper variant="outlined" sx={paperSectionSx}>
                                            <TextField
                                                id="partner-notes"
                                                name="notes"
                                                multiline
                                                rows={2}
                                                fullWidth
                                                placeholder="Enter notes"
                                                value={partnerNotes}
                                                onChange={(e) => {
                                                    setPartnerNotes(e.target.value);
                                                    setFieldValue('notes', e.target.value);
                                                }}
                                                sx={textFieldSx}
                                            />
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sx={{ mb: 3 }}>
                                        <Typography variant="overline" sx={sectionTitleSx}>Services</Typography>
                                        <Paper variant="outlined" sx={paperSectionSx}>
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name="isSurplusLinesTaxFilings"
                                                            checked={isSurplusLinesTaxFilings === true}
                                                            onChange={(e) => setIsSurplusLinesTaxFilings(e.target.checked)}
                                                            disabled={!isUserAdmin}
                                                        />
                                                    }
                                                    label={"Surplus Lines Tax Filings & Reporting"}
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name="isDiligentSearch" 
                                                            onChange={handleDiligentSearch}
                                                            checked={DiligentSearch === true ? true : false}
                                                            disabled={!isUserAdmin}
                                                        />
                                                    }
                                                    label={"Diligent Searches"}
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name="isConsulting"
                                                            checked={isConsulting === true}
                                                            onChange={(e) => setIsConsulting(e.target.checked)}
                                                            disabled={!isUserAdmin}
                                                        />
                                                    }
                                                    label={"Consulting"}
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name="isLicensing"
                                                            checked={isLicensingService === true}
                                                            onChange={(e) => setIsLicensingService(e.target.checked)}
                                                            disabled={!isUserAdmin}
                                                        />
                                                    }
                                                    label={"Licensing"}
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name="isOtherService"
                                                            checked={isOtherService === true}
                                                            onChange={(e) => {
                                                                const checked = e.target.checked;
                                                                setIsOtherService(checked);
                                                                setShowOtherTextField(checked);
                                                                if (!checked) {
                                                                    setOtherServiceNotes('');
                                                                }
                                                            }}
                                                            disabled={!isUserAdmin}
                                                        />
                                                    }
                                                    label={"Other"}
                                                />
                                                {showOtherTextField && (
                                                    <TextField
                                                        className='text-field-1'
                                                        name="otherServiceNotes"
                                                        value={otherServiceNotes}
                                                        onChange={(e) => setOtherServiceNotes(e.target.value)}
                                                        autoFocus
                                                        disabled={!isUserAdmin}
                                                        size="small"
                                                        type="text"
                                                        variant="outlined"
                                                        sx={textFieldSx}
                                                    />
                                                )}
                                            </Box>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sx={{ mb: 3 }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                            <Typography variant="overline" sx={{...sectionTitleSx, mb: 0, alignSelf: 'end', lineHeight: '1.5'}}>Filing Contact Information</Typography>
                                            <Button startIcon={<AddOutlinedIcon />} variant="contained" size="small" onClick={() => { setFilingContactArry(filingContactArry => [...filingContactArry, createNewPartnerContactRow()]); }} sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: '#2099d2', '&:hover': { backgroundColor: '#176990' } }}>Add More</Button>
                                        </Box>
                                        <Paper variant="outlined" sx={paperSectionSx}>
                                            {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                                <span />
                                                <Button variant="contained" size="small" onClick={() => { setFilingContactArry(filingContactArry => [...filingContactArry, createNewPartnerContactRow()]); }} sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: '#2099d2', '&:hover': { backgroundColor: '#176990' } }}>Add More</Button>
                                            </Box> */}
                                            {!isContactInfoLoading ?
                                                filingContactArry?.map((contact) => (
                                                    <React.Fragment key={contact.partnerContactInformationId}>
                                                        <Grid container spacing={2} xs={12} className={`d-flex ms-0 align-items-center ${contact.partnerContactInformationId === filingContactArry[filingContactArry.length - 1].partnerContactInformationId ? 'mb-0' : 'mb-2 border-bottom pb-3'}`}>
                                                            <Grid item xl={2.3} lg={2.3} md={6} xs={12} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                <IconButton
                                                                    color="error"
                                                                    disabled={filingContactArry.length <= 1}
                                                                    title={filingContactArry.length <= 1 ? 'At least one contact is required' : 'Delete contact'}
                                                                        onClick={() =>
                                                                        handleDeletePartnerContactByContactType(
                                                                            contact.partnerContactInformationId,
                                                                            "Filing",
                                                                            () => fetchPartnerContactInfo("Filing", setFilingContactArry, setisContactInfoLoading),
                                                                            () => setFilingContactArry((prev) => prev.filter((c) => c.partnerContactInformationId !== contact.partnerContactInformationId))
                                                                        )
                                                                        }
                                                                        sx={{ marginTop: 3 }}
                                                                >
                                                                    <DeleteOutlineOutlinedIcon sx={{ color: '#dc3545' }} />
                                                                </IconButton>
                                                                <FormControl sx={{ width: '100%' }} >
                                                                    <FormHelperText className='formtexthelper-heading'> Name</FormHelperText>
                                                                    {/* <FMTextField name={"filingContactName_" + index} id={"filingContactName_" + index} defaultValue={filingContactArry[index].contactName} autoFocus margin="dense" type="text" fullWidth variant="outlined" sx={{ m: 2, width: '100%' }} /> */}
                                                                    <TextField name={`filingContactName_${contact.partnerContactInformationId}`} id={`filingContactName_${contact.partnerContactInformationId}`} value={contact.contactName ?? ''} onChange={(e) => updatePartnerContactField(contact.partnerContactInformationId, 'contactName', e.target.value, setFilingContactArry)} className='text-field-1' type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xl={2.2} lg={2.2} md={6} xs={12}>
                                                                <FormControl sx={{ width: '100%' }} >
                                                                    <FormHelperText className='formtexthelper-heading'>Email</FormHelperText>
                                                                    <TextField className='text-field-1' name={`filingContactEmail_${contact.partnerContactInformationId}`} id={`filingContactEmail_${contact.partnerContactInformationId}`} value={contact.contactEmail ?? ''} onChange={(e) => updatePartnerContactField(contact.partnerContactInformationId, 'contactEmail', e.target.value, setFilingContactArry)} label="" type="email" fullWidth variant="outlined" sx={textFieldSx} />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xl={2.3} lg={2.3} md={6} xs={12}>
                                                                <FormControl style={{ marginLeft: "3px" }} sx={{ width: '100.5%' }} >
                                                                    <FormHelperText className='formtexthelper-heading'> Phone Number</FormHelperText>
                                                                    <TextField className='text-field-1' name={`filingContactPhone_${contact.partnerContactInformationId}`} id={`filingContactPhone_${contact.partnerContactInformationId}`} value={contact.contactPhone ?? ''} onChange={(e) => updatePartnerContactField(contact.partnerContactInformationId, 'contactPhone', e.target.value, setFilingContactArry)} InputLabelProps={{ shrink: true }} type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xl={2.2} lg={2.2} md={6} xs={12}>
                                                                <FormControl sx={{ width: '100%' }} >
                                                                    <FormHelperText className='formtexthelper-heading '>Escalation</FormHelperText>
                                                                    <PartnerContactEscalationSelect
                                                                        value={contact.escalationLevel ?? 0}
                                                                        onChange={(level) => updatePartnerContactField(contact.partnerContactInformationId, 'escalationLevel', level, setFilingContactArry)}
                                                                    />
                                                                </FormControl>
                                                            </Grid>
                                                            {/* <Grid item xs={0.1}></Grid> */}
                                                            <Grid item xl={2} lg={3} md={6} xs={12}>
                                                                <FormControl sx={{ display: 'flex', alignItems: 'center', width: '100%' }} className='Notifications-label mt-3'>
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    name={`filingContactCheckBox_${contact.partnerContactInformationId}`}
                                                                                    id={`filingContactCheckBox_${contact.partnerContactInformationId}`}
                                                                                    checked={Boolean(contact.isAutoNotification)}
                                                                                    onChange={(e) => updatePartnerContactField(contact.partnerContactInformationId, 'isAutoNotification', e.target.checked, setFilingContactArry)}
                                                                                />
                                                                            }
                                                                            label={"Auto Notifications"}
                                                                        />
                                                                        
                                                                    </div>
                                                                </FormControl>
                                                            </Grid>

                                                        </Grid>
                                                    </React.Fragment>

                                                ))
                                                : ""}
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sx={{ mb: 3 }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                            <Typography variant="overline" sx={{...sectionTitleSx, mb: 0, alignSelf: 'end', lineHeight: '1.5'}}>Accounting Contact Information</Typography>
                                            <Button startIcon={<AddOutlinedIcon />} variant="contained" size="small" onClick={() => { setAcountingContactArry(acountingContactArry => [...acountingContactArry, createNewPartnerContactRow()]); }} sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: '#2099d2', '&:hover': { backgroundColor: '#176990' } }}>Add More</Button>
                                        </Box>
                                        <Paper variant="outlined" sx={paperSectionSx}>
                                            {!isaccountInfoLoading ?
                                                acountingContactArry?.map((contact) => (
                                                    <React.Fragment key={contact.partnerContactInformationId}>
                                                        <Grid container spacing={2} xs={12} className={`d-flex ms-0 align-items-center ${contact.partnerContactInformationId === acountingContactArry[acountingContactArry.length - 1].partnerContactInformationId ? 'mb-0' : 'mb-2 border-bottom pb-3'}`}>
                                                            <Grid item xl={2.3} lg={2.3} md={6} xs={12} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                <IconButton
                                                                    color="error"
                                                                    disabled={acountingContactArry.length <= 1}
                                                                    title={acountingContactArry.length <= 1 ? 'At least one contact is required' : 'Delete contact'}
                                                                    onClick={() =>
                                                                        handleDeletePartnerContactByContactType(
                                                                        contact.partnerContactInformationId,
                                                                        "Accounting",
                                                                        () => fetchPartnerContactInfo("Accounting", setAcountingContactArry, setisaccountInfoLoading),
                                                                        () => setAcountingContactArry((prev) => prev.filter((c) => c.partnerContactInformationId !== contact.partnerContactInformationId))
                                                                        )
                                                                    }
                                                                    sx={{ marginTop: 3 }}
                                                                >
                                                                    <DeleteOutlineOutlinedIcon sx={{ color: '#dc3545' }} />
                                                                </IconButton>
                                                                <FormControl sx={{ width: '100%' }} >
                                                                    <FormHelperText className='formtexthelper-heading'>Name</FormHelperText>
                                                                    <TextField className='text-field-1' name={`accountingContactName_${contact.partnerContactInformationId}`} id={`accountingContactName_${contact.partnerContactInformationId}`} value={contact.contactName ?? ''} onChange={(e) => updatePartnerContactField(contact.partnerContactInformationId, 'contactName', e.target.value, setAcountingContactArry)} label="" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xl={2.2} lg={2.2} md={6} xs={12}>
                                                                <FormControl sx={{ width: '100%' }} >
                                                                    <FormHelperText className='formtexthelper-heading'>Email</FormHelperText>
                                                                    <TextField className='text-field-1' name={`accountingContactEmail_${contact.partnerContactInformationId}`} id={`accountingContactEmail_${contact.partnerContactInformationId}`} value={contact.contactEmail ?? ''} onChange={(e) => updatePartnerContactField(contact.partnerContactInformationId, 'contactEmail', e.target.value, setAcountingContactArry)} label="" type="email" fullWidth variant="outlined" sx={textFieldSx} />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xl={2.3} lg={2.3} md={6} xs={12}>
                                                                <FormControl sx={{ width: '100%' }} >
                                                                    <FormHelperText className='formtexthelper-heading'>Phone Number</FormHelperText>
                                                                    <TextField className='text-field-1' name={`accountingContactPhone_${contact.partnerContactInformationId}`} id={`accountingContactPhone_${contact.partnerContactInformationId}`} value={contact.contactPhone ?? ''} onChange={(e) => updatePartnerContactField(contact.partnerContactInformationId, 'contactPhone', e.target.value, setAcountingContactArry)} label="" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xl={2.2} lg={2.2} md={6} xs={12}>

                                                                <FormControl sx={{ width: '100%' }} >
                                                                    <FormHelperText className='formtexthelper-heading '>Escalation</FormHelperText>
                                                                    <PartnerContactEscalationSelect
                                                                        value={contact.escalationLevel ?? 0}
                                                                        onChange={(level) => updatePartnerContactField(contact.partnerContactInformationId, 'escalationLevel', level, setAcountingContactArry)}
                                                                    />
                                                                </FormControl>
                                                            </Grid>
                                                            {/* <Grid item xs={0.1}></Grid> */}
                                                            <Grid item xl={2} lg={3} md={6} xs={12}>
                                                                <FormControl sx={{ display: 'flex', alignItems: 'center', width: '100%', mt: 3 }} className='Notifications-label'>
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    name={`accountingContactCheckBox_${contact.partnerContactInformationId}`}
                                                                                    id={`accountingContactCheckBox_${contact.partnerContactInformationId}`}
                                                                                    checked={Boolean(contact.isAutoNotification)}
                                                                                    onChange={(e) => updatePartnerContactField(contact.partnerContactInformationId, 'isAutoNotification', e.target.checked, setAcountingContactArry)}
                                                                                />
                                                                            }
                                                                            label={"Auto Notifications"}
                                                                        />
                                                                        
                                                                    </div>
                                                                </FormControl>
                                                            </Grid>
                                                        </Grid>

                                                    </React.Fragment>

                                                ))
                                                : ""}
                                        </Paper>
                                    </Grid>

                                    {/* Licensee(s) Contact Information - commented out */}
                                    {/* <Grid container spacing={1} xs={12}>
                                        <Grid container spacing={2} xs={12} marginLeft="3.3vw" marginBottom="50px">
                                            <Grid container spacing={2} xs={12} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Grid item style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <span className="sub-card-title">Licensee(s) Contact Information</span>
                                                    <button className="btn active-btn-blue" type="button" style={{ marginLeft: '15px', marginTop: '20px' }} onClick={() => { setLicenseesContactArry(licenseesContactArry => [...licenseesContactArry, initLicenseeContactInformation]) }}>Add More</button>
                                                </Grid>
                                            </Grid>
                                            {!isLicenseesInfoLoading ?
                                                licenseesContactArry.map((contact) => (
                                                    <React.Fragment key={contact.partnerLincenseeInformationId}>
                                                        <Grid container spacing={2} xs={12} className='d-flex align-items-center'>
                                                            <Grid item xl={3} lg={3} md={6} xs={12}>
                                                                <FormControl sx={{ width: '100%' }}>
                                                                    <FormHelperText className='formtexthelper-heading'> Name</FormHelperText>
                                                                    <TextField name={`licenseeContactName_${contact.partnerLincenseeInformationId}`} id={`licenseeContactName_${contact.partnerLincenseeInformationId}`} defaultValue={contact.contactName} className='text-field-1' margin="dense" type="text" fullWidth variant="outlined" sx={{ marginTop: 0, width: '100%' }} />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xl={3} lg={3} md={6} xs={12}>
                                                                <FormControl sx={{ width: '100%' }}>
                                                                    <FormHelperText className='formtexthelper-heading'>Email</FormHelperText>
                                                                    <TextField className='text-field-1' name={`licenseeContactEmail_${contact.partnerLincenseeInformationId}`} id={`licenseeContactEmail_${contact.partnerLincenseeInformationId}`} defaultValue={contact.contactEmail} margin="dense" label="" type="email" fullWidth variant="outlined" sx={{ marginTop: 0, width: '100%' }} />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xl={3} lg={3} md={6} xs={12}>
                                                                <FormControl style={{ marginLeft: "3px" }} sx={{ width: '100%' }}>
                                                                    <FormHelperText className='formtexthelper-heading'> Phone Number</FormHelperText>
                                                                    <TextField className='text-field-1' name={`licenseeContactPhone_${contact.partnerLincenseeInformationId}`} id={`licenseeContactPhone_${contact.partnerLincenseeInformationId}`} defaultValue={contact.contactPhone} margin="dense" InputLabelProps={{ shrink: true }} type="text" fullWidth variant="outlined" sx={{ marginTop: 0, width: '100%' }} />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={0.1}></Grid>
                                                            <Grid item xl={2} lg={3} md={6} xs={12}>
                                                                <FormControl sx={{ display: 'flex', alignItems: 'center', width: '100%' }} className='Notifications-label'>
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    name={`filingContactCheckBox_${contact.partnerLincenseeInformationId}`}
                                                                                    id={`filingContactCheckBox_${contact.partnerLincenseeInformationId}`}
                                                                                    defaultChecked={contact.isAutoNotification}
                                                                                    onChange={(e) => {
                                                                                        e.target.checked = e.target.checked ? true : false;
                                                                                        e.target.value = e.target.checked ? "true" : "false";
                                                                                    }}
                                                                                />
                                                                            }
                                                                            label={"Auto Notifications"}
                                                                        />
                                                                        <IconButton color="error" onClick={() => handleDeleteLicensee(contact.partnerLincenseeInformationId)}>
                                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M3 6H5M5 6H21M5 6V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V6H5ZM8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6" stroke="#162E3C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                            </svg>
                                                                        </IconButton>
                                                                    </div>
                                                                </FormControl>
                                                            </Grid>
                                                        </Grid>
                                                    </React.Fragment>
                                                ))
                                                : ""}
                                        </Grid>
                                    </Grid> */}
                                    <Grid item xs={12} sx={{ mb: 3 }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                            <Typography variant="overline" sx={{...sectionTitleSx, mb: 0, alignSelf: 'end', lineHeight: '1.5'}}>SLA Contact Information</Typography>
                                            <Button startIcon={<AddOutlinedIcon />} variant="contained" size="small" onClick={() => { setSLAAdminContactArry(slaAdminContactArry => [...slaAdminContactArry, createNewPartnerContactRow()]); }} sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: '#2099d2', '&:hover': { backgroundColor: '#176990' } }}>Add More</Button>
                                        </Box>
                                        <Paper variant="outlined" sx={paperSectionSx}>
                                            {!isSLAAdminInfoLoading ?
                                                slaAdminContactArry?.map((contact) => (
                                                    <React.Fragment key={contact.partnerContactInformationId}>
                                                        <Grid container spacing={2} xs={12} className={`d-flex ms-0 align-items-center ${contact.partnerContactInformationId === slaAdminContactArry[slaAdminContactArry.length - 1].partnerContactInformationId ? 'mb-0' : 'mb-2 border-bottom pb-3'}`}>
                                                            <Grid item xl={2.3} lg={2.3} md={6} xs={12} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                <IconButton
                                                                    color="error"
                                                                    disabled={slaAdminContactArry.length <= 1}
                                                                    title={slaAdminContactArry.length <= 1 ? 'At least one contact is required' : 'Delete contact'}
                                                                    onClick={() =>
                                                                        handleDeletePartnerContactByContactType(
                                                                            contact.partnerContactInformationId,
                                                                            "SLA",
                                                                            () => fetchPartnerContactInfo("SLA", setSLAAdminContactArry, setisSLAAdminInfoLoading),
                                                                            () => setSLAAdminContactArry((prev) => prev.filter((c) => c.partnerContactInformationId !== contact.partnerContactInformationId))
                                                                        )
                                                                        }
                                                                        sx={{ marginTop: 3 }}
                                                                >
                                                                    <DeleteOutlineOutlinedIcon sx={{ color: '#dc3545' }} />
                                                                </IconButton>
                                                                <FormControl sx={{ width: '100%' }} >
                                                                    <FormHelperText className='formtexthelper-heading'> Name</FormHelperText>
                                                                    {/* <FMTextField name={"filingContactName_" + index} id={"filingContactName_" + index} defaultValue={filingContactArry[index].contactName} autoFocus margin="dense" type="text" fullWidth variant="outlined" sx={{ m: 2, width: '100%' }} /> */}
                                                                    <TextField name={`slaAdminContactName_${contact.partnerContactInformationId}`} id={`slaAdminContactName_${contact.partnerContactInformationId}`} value={contact.contactName ?? ''} onChange={(e) => updatePartnerContactField(contact.partnerContactInformationId, 'contactName', e.target.value, setSLAAdminContactArry)} className='text-field-1' margin="dense" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xl={2.2} lg={2.2} md={6} xs={12}>
                                                                <FormControl sx={{ width: '100%' }} >
                                                                    <FormHelperText className='formtexthelper-heading'>Email</FormHelperText>
                                                                    <TextField className='text-field-1' name={`slaAdminContactEmail_${contact.partnerContactInformationId}`} id={`slaAdminContactEmail_${contact.partnerContactInformationId}`} value={contact.contactEmail ?? ''} onChange={(e) => updatePartnerContactField(contact.partnerContactInformationId, 'contactEmail', e.target.value, setSLAAdminContactArry)} margin="dense" label="" type="email" fullWidth variant="outlined" sx={textFieldSx} />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xl={2.3} lg={2.3} md={6} xs={12}>
                                                                <FormControl sx={{ width: '100%' }} >
                                                                    <FormHelperText className='formtexthelper-heading'> Phone Number</FormHelperText>
                                                                    <TextField className='text-field-1' name={`slaAdminContactPhone_${contact.partnerContactInformationId}`} id={`slaAdminContactPhone_${contact.partnerContactInformationId}`} value={contact.contactPhone ?? ''} onChange={(e) => updatePartnerContactField(contact.partnerContactInformationId, 'contactPhone', e.target.value, setSLAAdminContactArry)} margin="dense" InputLabelProps={{ shrink: true }} type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xl={2.2} lg={2.2} md={6} xs={12}>
                                                                <FormControl sx={{ width: '100%' }} >
                                                                    <FormHelperText className='formtexthelper-heading'>Escalation</FormHelperText>
                                                                    <PartnerContactEscalationSelect
                                                                        value={contact.escalationLevel ?? 0}
                                                                        onChange={(level) => updatePartnerContactField(contact.partnerContactInformationId, 'escalationLevel', level, setSLAAdminContactArry)}
                                                                    />
                                                                </FormControl>
                                                            </Grid>
                                                            {/* <Grid item xs={0.1}></Grid> */}
                                                            <Grid item xl={2} lg={3} md={6} xs={12}>
                                                                <FormControl sx={{ display: 'flex', alignItems: 'center', width: '100%', mt: 3 }} className='Notifications-label'>
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    name={`slaAdminContactCheckBox_${contact.partnerContactInformationId}`}
                                                                                    id={`slaAdminContactCheckBox_${contact.partnerContactInformationId}`}
                                                                                    checked={Boolean(contact.isAutoNotification)}
                                                                                    onChange={(e) => updatePartnerContactField(contact.partnerContactInformationId, 'isAutoNotification', e.target.checked, setSLAAdminContactArry)}
                                                                                />
                                                                            }
                                                                            label={"Auto Notifications"}
                                                                        />
                                                                        
                                                                    </div>
                                                                </FormControl>
                                                            </Grid>

                                                        </Grid>
                                                    </React.Fragment>

                                                ))
                                                : ""}
                                        </Paper>
                                    </Grid>

                                    <Grid item xs={12} sx={{ mb: 3 }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                            <Typography variant="overline" sx={{...sectionTitleSx, mb: 0, alignSelf: 'end', lineHeight: '1.5'}}>Escalation Contact Information</Typography>
                                            <Button startIcon={<AddOutlinedIcon />} variant="contained" size="small" onClick={() => { setEscalationContactArry(escalationContactArry => [...escalationContactArry, createNewPartnerContactRow()]); }} sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: '#2099d2', '&:hover': { backgroundColor: '#176990' } }}>Add More</Button>
                                        </Box>
                                        <Paper variant="outlined" sx={paperSectionSx}>
                                            {!isEscalationInfoLoading ?
                                                escalationContactArry?.map((contact) => (
                                                    <React.Fragment key={contact.partnerContactInformationId}>
                                                        <Grid container spacing={2} xs={12} className={`d-flex ms-0 align-items-center ${contact.partnerContactInformationId === escalationContactArry[escalationContactArry.length - 1].partnerContactInformationId ? 'mb-0' : 'mb-2 border-bottom pb-3'}`}>
                                                            <Grid item xl={2.3} lg={2.3} md={6} xs={12} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                <IconButton
                                                                    color="error"
                                                                    disabled={escalationContactArry.length <= 1}
                                                                    title={escalationContactArry.length <= 1 ? 'At least one contact is required' : 'Delete contact'}
                                                                    onClick={() =>
                                                                        handleDeletePartnerContactByContactType(
                                                                            contact.partnerContactInformationId,
                                                                            "Escalation",
                                                                            () => fetchPartnerContactInfo("Escalation", setEscalationContactArry, setisEscalationInfoLoading),
                                                                            () => setEscalationContactArry((prev) => prev.filter((c) => c.partnerContactInformationId !== contact.partnerContactInformationId))
                                                                        )
                                                                        }
                                                                        sx={{ marginTop: 3 }}
                                                                >
                                                                    <DeleteOutlineOutlinedIcon sx={{ color: '#dc3545' }} />
                                                                </IconButton>
                                                                <FormControl sx={{ width: '100%' }} >
                                                                    <FormHelperText className='formtexthelper-heading'> Name</FormHelperText>
                                                                    <TextField name={`escalationContactName_${contact.partnerContactInformationId}`} id={`escalationContactName_${contact.partnerContactInformationId}`} value={contact.contactName ?? ''} onChange={(e) => updatePartnerContactField(contact.partnerContactInformationId, 'contactName', e.target.value, setEscalationContactArry)} className='text-field-1' margin="dense" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xl={2.2} lg={2.2} md={6} xs={12}>
                                                                <FormControl sx={{ width: '100%' }} >
                                                                    <FormHelperText className='formtexthelper-heading'>Email</FormHelperText>
                                                                    <TextField className='text-field-1' name={`escalationContactEmail_${contact.partnerContactInformationId}`} id={`escalationContactEmail_${contact.partnerContactInformationId}`} value={contact.contactEmail ?? ''} onChange={(e) => updatePartnerContactField(contact.partnerContactInformationId, 'contactEmail', e.target.value, setEscalationContactArry)} margin="dense" label="" type="email" fullWidth variant="outlined" sx={textFieldSx} />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xl={2.3} lg={2.3} md={6} xs={12}>
                                                                <FormControl sx={{ width: '100%' }} >
                                                                    <FormHelperText className='formtexthelper-heading'> Phone Number</FormHelperText>
                                                                    <TextField className='text-field-1' name={`escalationContactPhone_${contact.partnerContactInformationId}`} id={`escalationContactPhone_${contact.partnerContactInformationId}`} value={contact.contactPhone ?? ''} onChange={(e) => updatePartnerContactField(contact.partnerContactInformationId, 'contactPhone', e.target.value, setEscalationContactArry)} margin="dense" InputLabelProps={{ shrink: true }} type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xl={2.2} lg={2.2} md={6} xs={12}>
                                                                <FormControl sx={{ width: '100%' }} >
                                                                    <FormHelperText className='formtexthelper-heading'>Escalation</FormHelperText>
                                                                    <PartnerContactEscalationSelect
                                                                        value={contact.escalationLevel ?? 0}
                                                                        onChange={(level) => updatePartnerContactField(contact.partnerContactInformationId, 'escalationLevel', level, setEscalationContactArry)}
                                                                    />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xl={2} lg={3} md={6} xs={12}>
                                                                <FormControl sx={{ display: 'flex', alignItems: 'center', width: '100%', mt: 3 }} className='Notifications-label'>
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    name={`escalationContactCheckBox_${contact.partnerContactInformationId}`}
                                                                                    id={`escalationContactCheckBox_${contact.partnerContactInformationId}`}
                                                                                    checked={Boolean(contact.isAutoNotification)}
                                                                                    onChange={(e) => updatePartnerContactField(contact.partnerContactInformationId, 'isAutoNotification', e.target.checked, setEscalationContactArry)}
                                                                                />
                                                                            }
                                                                            label={"Auto Notifications"}
                                                                        />
                                                                    </div>
                                                                </FormControl>
                                                            </Grid>
                                                        </Grid>
                                                    </React.Fragment>
                                                ))
                                                : ""}
                                        </Paper>
                                    </Grid>

                                    <Grid item xs={12} sx={{ mb: 3 }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                            <Typography variant="overline" sx={{...sectionTitleSx, mb: 0, alignSelf: 'end', lineHeight: '1.5'}}>DRLP Contact Information</Typography>
                                            <Button startIcon={<AddOutlinedIcon />} variant="contained" size="small" onClick={() => { setDRLPContactArry(drlpContactArry => [...drlpContactArry, createNewPartnerContactRow()]); }} sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: '#2099d2', '&:hover': { backgroundColor: '#176990' } }}>Add More</Button>
                                        </Box>
                                        <Paper variant="outlined" sx={paperSectionSx}>
                                            {!isDRLPInfoLoading ?
                                                drlpContactArry?.map((contact) => (
                                                    <React.Fragment key={contact.partnerContactInformationId}>
                                                        <Grid container spacing={2} xs={12} className={`d-flex ms-0 align-items-center ${contact.partnerContactInformationId === drlpContactArry[drlpContactArry.length - 1].partnerContactInformationId ? 'mb-0' : 'mb-2 border-bottom pb-3'}`}>
                                                            <Grid item xl={2} lg={2} md={6} xs={12} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <IconButton
                                                                            color="error"
                                                                            disabled={drlpContactArry.length <= 1}
                                                                            title={drlpContactArry.length <= 1 ? 'At least one contact is required' : 'Delete contact'}
                                                                            onClick={() =>
                                                                                handleDeletePartnerContactByContactType(
                                                                                  contact.partnerContactInformationId,
                                                                                  "DRLP",
                                                                                  () => fetchPartnerContactInfo("DRLP", setDRLPContactArry, setisDRLPInfoLoading),
                                                                                  () => setDRLPContactArry((prev) => prev.filter((c) => c.partnerContactInformationId !== contact.partnerContactInformationId))
                                                                                )
                                                                              }
                                                                        sx={{ marginTop: 3 }}
                                                                >
                                                                    <DeleteOutlineOutlinedIcon sx={{ color: '#dc3545' }} />
                                                                </IconButton>
                                                                <FormControl sx={{ width: '100%' }} >
                                                                    <FormHelperText className='formtexthelper-heading'> Name</FormHelperText>
                                                                    <TextField name={`drlpContactName_${contact.partnerContactInformationId}`} id={`drlpContactName_${contact.partnerContactInformationId}`} value={contact.contactName ?? ''} onChange={(e) => updatePartnerContactField(contact.partnerContactInformationId, 'contactName', e.target.value, setDRLPContactArry)} className='text-field-1' margin="dense" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xl={2} lg={2} md={6} xs={12}>
                                                                <FormControl sx={{ width: '100%' }} >
                                                                    <FormHelperText className='formtexthelper-heading'>Email</FormHelperText>
                                                                    <TextField className='text-field-1' name={`drlpContactEmail_${contact.partnerContactInformationId}`} id={`drlpContactEmail_${contact.partnerContactInformationId}`} value={contact.contactEmail ?? ''} onChange={(e) => updatePartnerContactField(contact.partnerContactInformationId, 'contactEmail', e.target.value, setDRLPContactArry)} margin="dense" label="" type="email" fullWidth variant="outlined" sx={textFieldSx} />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xl={2} lg={2} md={6} xs={12}>
                                                                <FormControl sx={{ width: '100%' }} >
                                                                    <FormHelperText className='formtexthelper-heading'> Phone Number</FormHelperText>
                                                                    <TextField className='text-field-1' name={`drlpContactPhone_${contact.partnerContactInformationId}`} id={`drlpContactPhone_${contact.partnerContactInformationId}`} value={contact.contactPhone ?? ''} onChange={(e) => updatePartnerContactField(contact.partnerContactInformationId, 'contactPhone', e.target.value, setDRLPContactArry)} margin="dense" InputLabelProps={{ shrink: true }} type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xl={1.8} lg={1.8} md={6} xs={12}>
                                                                <FormControl sx={{ width: '100%' }} >
                                                                    <FormHelperText className='formtexthelper-heading'>Escalation</FormHelperText>
                                                                    <PartnerContactEscalationSelect
                                                                        value={contact.escalationLevel ?? 0}
                                                                        onChange={(level) => updatePartnerContactField(contact.partnerContactInformationId, 'escalationLevel', level, setDRLPContactArry)}
                                                                    />
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xl={1.8} lg={1.8} md={6} xs={12}>
                                                                <FormControl sx={{ width: '100%' }} >
                                                                    <FormHelperText className='formtexthelper-heading'>State</FormHelperText>
                                                                    <PartnerContactMultiStateSelect
                                                                        value={contact.stateIds ?? []}
                                                                        onChange={(stateIds) => updatePartnerContactField(contact.partnerContactInformationId, 'stateIds', stateIds, setDRLPContactArry)}
                                                                    />
                                                                </FormControl>
                                                            </Grid>
                                                            {/* <Grid item xs={0.1}></Grid> */}
                                                            <Grid item xl={2} lg={3} md={6} xs={12}>
                                                                <FormControl sx={{ display: 'flex', alignItems: 'center', width: '100%', mt: 3 }} className='Notifications-label'>
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    name={`drlpContactCheckBox_${contact.partnerContactInformationId}`}
                                                                                    id={`drlpContactCheckBox_${contact.partnerContactInformationId}`}
                                                                                    checked={Boolean(contact.isAutoNotification)}
                                                                                    onChange={(e) => updatePartnerContactField(contact.partnerContactInformationId, 'isAutoNotification', e.target.checked, setDRLPContactArry)}
                                                                                />
                                                                            }
                                                                            label={"Auto Notifications"}
                                                                        />
                                                                        
                                                                    </div>
                                                                </FormControl>
                                                            </Grid>

                                                        </Grid>
                                                    </React.Fragment>

                                                ))
                                                : ""}
                                        </Paper>
                                    </Grid>

                                    <Grid item xs={12} sx={{ mb: 3 }}>
                                        <Typography variant="overline" sx={sectionTitleSx}>Integrations</Typography>
                                        <Paper variant="outlined" sx={paperSectionSx}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} md={3.5}>
                                                    <FormControl sx={{ width: '100%' }}>
                                                        <FormHelperText className='formtexthelper-heading'>Integration Type</FormHelperText>
                                                        <FMSelectPartnerIntegrationType name="partnerIntegrationType" />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={3.5}>
                                                    <FormControl sx={{ width: '100%' }}>
                                                        <FormHelperText className='formtexthelper-heading'>Agency/Policy Management System</FormHelperText>
                                                        <FMTextField name="agencyPolicyManagementSystem" disabled={!(user?.userRoles.split(",").includes("Super Admin") || user?.userRoles.split(",").includes("MISC Filer"))} label={null} margin="dense" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={5}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
                                                        <FormControl sx={{ width: '100%' }}>
                                                            <FormHelperText className='formtexthelper-heading'>Generate Api</FormHelperText>
                                                            <FMTextField name="apiToken" label={null} margin="dense" type="text" fullWidth variant="outlined" sx={textFieldSx} InputProps={{ readOnly: true }} />
                                                        </FormControl>
                                                        <Button startIcon={<VpnKeyOutlinedIcon />} variant="outlined" size="large" type="button" onClick={() => handleButtonClick(setFieldValue)} sx={{ textTransform: 'none', py: 1.5, px: 5, fontWeight: 600, borderColor: '#e2e8f0', color: '#475569', whiteSpace: 'nowrap', mt: 3.5, '&:hover': { borderColor: '#2099d2', backgroundColor: '#2099d214', color: '#2099d2' } }}>Generate Key</Button>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>

                                    {/* Carriers section - commented out */}

                                    {/* Per-client filing coverage-code defaults (Jerry, 2026-07-16): the same
                                        per-partner-per-state coverage-code override the Batch Filing Review edits,
                                        surfaced here on the client page (coverage-only). Same clientFilingDefaults
                                        source, so both stay in sync. Only for an existing client. */}
                                    {params.partnersId !== '0' && (
                                        <Grid item xs={12} sx={{ mb: 3 }}>
                                            <Typography variant="overline" sx={sectionTitleSx}>Filing coverage defaults</Typography>
                                            <Paper variant="outlined" sx={paperSectionSx}>
                                                <ClientFilingDefaultsPanel coverageOnly token={token} partnersId={Number(params.partnersId)} partnerName={values.customerName} />
                                            </Paper>
                                        </Grid>
                                    )}

                                    {/* Per-client filing CREDENTIALS (Jerry, 2026-07-22): the API key per state (+ username
                                        where the system uses one) for Client-login states, and the client identifier for
                                        MISC-login states. Admin-only (Super Admin) — this page also admits Customer Admin,
                                        so the section is gated here rather than on the route. Write-only: a set key is never
                                        shown back. Only for an existing client. */}
                                    {params.partnersId !== '0' && isUserAdmin && (
                                        <Grid item xs={12} sx={{ mb: 3 }}>
                                            <Typography variant="overline" sx={sectionTitleSx}>Filing credentials</Typography>
                                            <Paper variant="outlined" sx={paperSectionSx}>
                                                <StateFilingCredentialsPanel token={token} partnersId={Number(params.partnersId)} partnerName={values.customerName} canManage={isUserAdmin} />
                                            </Paper>
                                        </Grid>
                                    )}

                                    <Grid item xs={12}>
                                        <Box sx={{ borderTop: 1, borderColor: 'divider', backgroundColor: 'grey.50', px: { xs: 2, sm: 3 }, py: 2, mt: 2, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1.5, flexWrap: 'wrap' }}>
                                            {loading && <CircularProgress size={24} sx={{ mr: 1 }} />}
                                            <Button startIcon={<SaveOutlinedIcon />} variant="contained" size="medium" type="submit" disabled={user?.userRoles.split(",").includes("MISC Filer") || loading} sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: '#2099d2', '&:hover': { backgroundColor: '#176990' }, px: 2.5 }}>Save</Button>
                                        </Box>
                                    </Grid>
                                </Box>
                            </Box>
                        </Form>

                        <AddEditPartnerAgencyDetails partnerAgencyDetail={PartnerAgencyData} setPartnerAgencyDetailList={setPartnerAgencyDetailList} Open={Open} setopen={setOpen} partnerAgencyDetailList={partnerAgencyDetailList} addselectedStates={addselectedStates} removeSelectedStates={RemoveSelected} stateName={StateName} />

                    </React.Fragment>
                )}


            </Formik>
        </React.Fragment>
        /* </div>
      </div>
  </div>
</div>
</div>
</div>
</div>
<RightNav />

</div>
</div>
</div>

</main>
</section> */



    )
}
